import invariant from 'invariant';

import type { I18nLocale } from '#/i18n/types/I18nLocale';

// oxlint-disable-next-line typescript/no-explicit-any
function insertScript(locale: I18nLocale, onLoaded: any) {
  const recaptchaScript = document.createElement('script');
  // @ts-expect-error TS(2339): Property 'recaptchaOnloadCallback' does not exist ... Remove this comment to see the full error message
  window.recaptchaOnloadCallback = onLoaded;
  recaptchaScript.setAttribute(
    'src',
    `//www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&` +
      `render=explicit&hl=${locale}`,
  );
  recaptchaScript.setAttribute('async', 'async');
  recaptchaScript.setAttribute('defer', 'defer');
  invariant(document.head, 'Missing document.head');
  document.head.appendChild(recaptchaScript);
}

// oxlint-disable-next-line typescript/no-explicit-any
let loadingPromise: any;

export function resetRecaptcha() {
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  return window && window.grecaptcha && window.grecaptcha.reset();
}

export function recaptcha({ locale }: { locale: I18nLocale }) {
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  loadingPromise ??= new Promise<any>((resolve) => {
    insertScript(locale, () => {
      resolve(grecaptcha);
    });
  });

  return loadingPromise;
}
